const cardsData = [
  {
    image: 'https://readdy.ai/api/search-image?query=Elegant%20dressing%20room%20with%20designer%20clothes%20scattered%2C%20warm%20crimson%20and%20gold%20lighting%2C%20luxurious%20yet%20chaotic%20atmosphere%2C%20editorial%20fashion%20photography%2C%20no%20people&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '娱乐圈',
    title: '知名女星被拍到深夜出入神秘豪宅',
    excerpt: '狗仔队连续蹲守三天，拍到该女星多次深夜出入某高档小区，疑似新恋情曝光...',
    time: '2 小时前',
    views: '3.2 万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20social%20media%20feed%20with%20dramatic%20red%20notification%20bubbles%2C%20dark%20moody%20background%2C%20glowing%20screen%20light%2C%20modern%20tech%20aesthetic%2C%20no%20recognizable%20text&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '网红圈',
    title: '百万粉美妆博主被扒学历造假',
    excerpt: '网友晒出学信网截图实锤，该博主所谓名校毕业纯属虚构。目前已删除所有简介信息...',
    time: '4 小时前',
    views: '6.8 万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20concert%20stage%20with%20empty%20microphone%20stand%20under%20single%20amber%20spotlight%2C%20dramatic%20theatrical%20atmosphere%2C%20abandoned%20guitar%20in%20background%2C%20mysterious%20vibe%2C%20no%20people&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '音乐圈',
    title: '某乐队主唱演唱会中途离场引众怒',
    excerpt: '现场观众录制视频显示，主唱在第三首歌后突然摔麦走人，主办方临时宣布演出取消...',
    time: '6 小时前',
    views: '4.5 万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20film%20set%20with%20director%20chair%20and%20scattered%20scripts%2C%20dramatic%20crimson%20lighting%2C%20behind%20the%20scenes%20chaos%2C%20cinematic%20composition%2C%20no%20people&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '影视圈',
    title: '某大制作剧组被曝拖欠群演工资',
    excerpt: '多位群众演员联合发声，称已连续三个月未收到报酬。制片方目前尚未作出任何回应...',
    time: '8 小时前',
    views: '2.1 万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Sports%20arena%20locker%20room%20with%20abandoned%20jersey%20on%20bench%2C%20dramatic%20lighting%2C%20tension%20atmosphere%2C%20dark%20and%20moody%2C%20editorial%20sports%20photography%2C%20no%20people&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '体育圈',
    title: '某运动员被指违规使用兴奋剂',
    excerpt: '匿名举报信曝光后引发轩然大波，赛事组委会表示已启动调查程序...',
    time: '10 小时前',
    views: '5.7 万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Gaming%20setup%20with%20neon%20red%20and%20purple%20lights%2C%20empty%20gaming%20chair%2C%20streaming%20equipment%2C%20dark%20room%20vibe%2C%20modern%20esports%20aesthetic%2C%20no%20people&width=600&height=400&seq=card-06&orientation=landscape',
    tag: '电竞圈',
    title: '某战队内部聊天记录外泄引争议',
    excerpt: '涉及队员私下讨论转会与合同细节的截图疯传，俱乐部凌晨紧急发布澄清公告...',
    time: '14 小时前',
    views: '3.9 万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=TV%20studio%20control%20room%20with%20multiple%20monitors%20showing%20static%2C%20dramatic%20red%20emergency%20lighting%2C%20abandoned%20broadcast%20equipment%2C%20tense%20atmosphere%2C%20no%20people&width=600&height=400&seq=card-07&orientation=landscape',
    tag: '综艺圈',
    title: '某选秀节目被质疑黑幕操作',
    excerpt: '淘汰选手发文暗示赛制不公，粉丝后援会晒出投票数据要求节目组公开透明...',
    time: '16 小时前',
    views: '7.4 万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">今日大瓜</h2>
          <p className="mt-2 text-sm text-foreground-600">24 小时内最火爆的八卦资讯，吃瓜群众速来围观</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cardsData.map((item, i) => (
            <article
              key={i}
              className="group cursor-pointer bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:border-accent-300/50 transition-all duration-300 flex flex-col"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-44 object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors leading-snug line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2 flex-1">{item.excerpt}</p>
                <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                  <span>{item.time}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {item.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}